import { Spacer, Typo } from 'components/ui-kit';
import React from 'react';
import styles from './map.module.scss';

type TInfoRowProps = {
  title: string;
  content: string;
};

export const InfoRow = ({ title, content }: TInfoRowProps): JSX.Element => (
  <>
    <Typo variant="2xl" className={styles.infoTitle} weight="500">
      {title}
    </Typo>
    <Spacer size={8} />
    <Typo
      variant="m"
      className={styles.infoContent}
      weight="500"
      color="secondary"
    >
      {content}
    </Typo>
  </>
);
